import { createTheme } from '@mui/material';
var defaultTheme = createTheme({
    palette: {
        error: {
            contrastText: '#FFF',
            main: '#C42323',
        },
        info: {
            contrastText: '#FFF',
            main: '#007EA8',
        },
        neutral: {
            black0: '#FFF',
            black5: '#F1F1F1',
            black10: '#E8E8E8',
            black15: '#D6D6D6',
            black20: '#C7C7C7',
            black40: '#999',
            black55: '#757575',
            black60: '#666',
            black65: '#525252',
            black70: '#4D4D4D',
            black75: '#404040',
            black80: '#333',
            black100: '#000',
        },
        primary: {
            contrastText: '#FFF',
            dark: '#52356E',
            light: '#EDE5F5',
            main: '#3F2A56',
        },
        secondary: {
            contrastText: '#FFF',
            dark: '#006789',
            light: '#009BCD',
            main: '#007EA8',
        },
        success: {
            contrastText: '#FFF',
            main: '#00A857',
        },
        tertiary: {
            contrastText: '#FFF',
            dark: '#D93620',
            light: '#FF6754',
            main: '#E14632',
        },
        text: {},
        warning: {
            contrastText: '#FFF',
            main: '#D1850A',
        },
    },
    typography: {
        body1: {
            fontSize: 'inherit',
        },
        body2: {
            fontSize: 'inherit',
        },
        fontFamily: ['Source Sans Pro', 'sans-serif'].join(','),
    },
});
export default defaultTheme;
